import * as actions from './actions';

import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';

export const getQrCodeEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(actions.getQrCode.request)),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      const ajaxResponse = apiClient(state).getQrCode(payload);

      return ajaxResponse.pipe(
        map(data => {
          return actions.getQrCode.success({ content: payload.content, svg: data.response });
        }),
        catchError((error: Error) => of(actions.getQrCode.failure({ error }))),
      );
    }),
  );
